module.exports = __webpack_public_path__ + "static/media/logo.3ab782e3.png";